export type ChatTranscriptMessage = {
  id?: string;
  role: "user" | "assistant";
  content: string;
};

/** Older pages sit above the current one. A repeated id is already on screen. */
export function prependOlderMessages<T extends { id?: string }>(
  current: T[],
  older: T[],
): T[] {
  if (older.length === 0) return current;
  const seen = new Set(current.map((message) => message.id).filter(Boolean));
  const fresh = older.filter((message) => !message.id || !seen.has(message.id));
  return [...fresh, ...current];
}
